<template>
  <!-- Mobile -->
  <v-sheet
    v-if="$vuetify.breakpoint.smAndDown && data.items.length > 0"
    class="transparent mt-8"
    width="100%"
  >
    <!-- Video Cassino ao vivo -->
    <div class="my-2 mb-8" v-if="data.category_name === $t('liveCasino')">
      <div class="neonLine">
        <div class="neonLineBlur"></div>
        <div class="neonLineWhite"></div>
      </div>
      <div style="position: relative;">
        <v-skeleton-loader
          v-if="!videoLoaded"
          type="image"
          style="height: 200px;"
        ></v-skeleton-loader>
        <video
          v-show="videoLoaded"
          width="100%"
          height="100%"
          autoplay
          muted
          loop
          webkit-playsinline
          playsinline
          class="videoLiveCasinoMobile"
          style="object-fit: cover; filter: blur(0);"
          @canplaythrough="() => data && (videoLoaded = true)"
        >
          <source src="https://dozr8la71aog.cloudfront.net/videos/pragmaticplay/PRAGMATIC+PLAY+SEEKS+HEAVENLY+FAVOUR+IN+QUEEN+OF+GODS%E2%84%A2.mp4" type="video/mp4">
        </video>
        <v-btn
          color="primary"
          small
          style="
            position: absolute;
            right: 12px;
            bottom: 28px;
            border-radius: 8px;
          "
          @click="gameClicked(queenOfGodsGame, false)"
        >
          {{ $t("play") }}
        </v-btn>
      </div>
      <div class="neonLine">
        <div class="neonLineBlur"></div>
        <div class="neonLineWhite"></div>
      </div>
    </div>

    <!-- Nome da categoria e ver todos -->
    <div class="d-flex justify-space-between align-end my-3">
      <div
        class="text-h6"
        style="filter: blur(0);"
      >
        {{ data.category_name }}
      </div>
      <div
        style="filter: blur(0);"
      >
        <v-hover v-slot="{ hover }">
          <v-btn
            text
            :color="hover ? 'primary' : ''"
            :small="$vuetify.breakpoint.smAndDown"
            class="px-2 caption"
            @click="goGamesCategory(data.category_name, true)"
          >
            {{ $t('seeAllGamesCategory') }}
          </v-btn>
        </v-hover>
      </div>
    </div>

    <!-- Listagem dos jogos -->
    <div class="casino-slider d-flex">
      <div v-for="(game, index) in data.items" :key="index">
        <v-card
          class="transparent"
          :class="index === 0 ? 'mr-1' : 'mx-1'"
          width="150"
          elevation="0"
        >
          <v-hover v-slot="{ hover }">
            <v-img
              :key="`${gameAPI}/game_pic/rec/325/${game.id_game_simple}.png`"
              :src="`${gameAPI}/game_pic/rec/325/${game.id_game_simple}.png`"
              max-width="150"
              :class="index + 1 === data.items.length ? 'mr-2' : ''"
              style="border-radius: 8px;"
              @load="game.imageLoaded = true"
            >
              <v-skeleton-loader
                v-if="!game.imageLoaded"
                type="image"
                style="height: 100px;"
              >
              </v-skeleton-loader>
              <v-overlay opacity="0.7" absolute v-if="hover && game.imageLoaded">
                <div class="d-flex flex-column">
                  <v-btn
                    color="primary"
                    small
                    style="border-radius: 8px;"
                    @click="gameClicked(game, false)"
                  >
                    {{ $t("play") }}
                  </v-btn>
                  <v-btn
                    v-if="game.id_tipo !== 'lg'"
                    color="primary"
                    small
                    outlined
                    class="mt-2"
                    style="
                      background-color: black;
                      border-radius: 8px;
                      border-width: 2px;
                      opacity: 0.8;
                    "
                    @click="gameClicked(game, true)"
                  >
                    DEMO
                  </v-btn>
                </div>
              </v-overlay>
            </v-img>
          </v-hover>
        </v-card>
      </div>
    </div>
  </v-sheet>

  <!-- Desktop -->
  <v-sheet
    v-else-if="!$vuetify.breakpoint.smAndDown && data.items.length > 0"
    class="transparent mt-5"
    width="100%"
  >
    <!-- Video Cassino ao vivo -->
    <div
      v-if="data.category_name === $t('liveCasino')"
      class="my-2 mb-15"
    >
      <div class="neonLine">
        <div class="neonLineBlur"></div>
        <div class="neonLineWhite"></div>
      </div>
      <div style="position: relative;">
        <v-skeleton-loader
          v-if="!videoLoaded"
          type="image"
          style="height: 600px;"
        ></v-skeleton-loader>
        <video
          v-show="videoLoaded"      
          width="100%"
          height="100%"
          autoplay
          muted
          loop
          webkit-playsinline
          playsinline
          class="videoLiveCasino"
          style="object-fit: cover; filter: blur(0);"
          @canplaythrough="() => data && (videoLoaded = true)"
        >
          <source src="https://dozr8la71aog.cloudfront.net/videos/pragmaticplay/PRAGMATIC+PLAY+SEEKS+HEAVENLY+FAVOUR+IN+QUEEN+OF+GODS%E2%84%A2.mp4" type="video/mp4">
        </video>
        <v-btn
          color="primary"
          style="
            width: 85px;
            position: absolute;
            right: 24px;
            bottom: 52px;
            border-radius: 8px;
          "
          @click="gameClicked(queenOfGodsGame, false)"
        >
          {{ $t("play") }}
        </v-btn>
      </div>
      <div class="neonLine">
        <div class="neonLineBlur"></div>
        <div class="neonLineWhite"></div>
      </div>
    </div>

    <!-- Nome da categoria e ver todos -->
    <div class="d-flex justify-space-between align-end my-3">
      <div
        class="text-h5"
        style="filter: blur(0);"
      >
        {{ data.category_name }}
      </div>
      <div 
        style="filter: blur(0);"
      >
        <v-hover v-slot="{ hover }">
          <v-btn
            text
            :color="hover ? 'primary' : ''"
            class="px-2 subtitle-1"
            @click="goGamesCategory(data.category_name, true)"
          >
            {{ $t('seeAllGamesCategory') }}
          </v-btn>
        </v-hover>
      </div>
    </div>

    <!-- Listagem dos jogos -->
    <v-slide-group
      v-model="model"
      :show-arrows="!$vuetify.breakpoint.smAndDown"
    >
      <template v-slot:prev class="pa-14">
        <v-icon
          size="40"
          class="primary"
          style="border-radius: 2rem;"
        >
          mdi-chevron-left
        </v-icon>
      </template>
      <template v-slot:next>
        <v-icon
          size="40"
          class="primary"
          style="border-radius: 2rem;"
        >
          mdi-chevron-right
        </v-icon>
      </template>
      <div class="row my-1 align-center">
        <v-slide-item
          v-for="(game, index) in data.items"
          :key="index"
          v-slot:default="{ toggle }"
        >
          <div
            class="
              transparent
              v-card
              v-card--link
              v-sheet
              theme--dark
              elevation-0
              d-flex
              align-center
              mx-2
            "
            style="width: 250px; height: 180px;"
            @click="toggle"
          >
            <v-hover v-slot="{ hover }">
              <div
                class="v-image v-responsive theme--dark"
                :class="index + 1 === data.items.length ? 'mr-2' : ''"
                style="max-width: 250px; border-radius: 8px;"
              >
                <div class="v-responsive__sizer" style="padding-bottom: 72%;"></div>
                <img
                  class="v-image__image v-image__image--cover"
                  :src="`${gameAPI}/game_pic/rec/325/${game.id_game_simple}.png`"
                  :style="{
                    'background-position': 'center center',
                  }"
                  @load="game.imageLoaded = true"
                >
                <div class="v-responsive__content" style="width: 325px;"></div>
                <v-skeleton-loader
                  v-if="!game.imageLoaded"
                  type="image"
                  style="height: 180px;"
                >
                </v-skeleton-loader>
                <v-overlay opacity="0.7" absolute v-if="hover && game.imageLoaded">
                  <div class="d-flex flex-column">
                    <v-btn
                      color="primary"
                      style="border-radius: 8px;"
                      @click="gameClicked(game, false)"
                    >
                      {{ $t("play") }}
                    </v-btn>
                    <v-btn
                      v-if="game.id_tipo !== 'lg'"
                      color="primary"
                      outlined
                      class="mt-3"
                      style="
                        background-color: black;
                        border-radius: 8px;
                        border-width: 2px;
                        opacity: 0.8;
                      "
                      @click="gameClicked(game, true)"
                    >
                      DEMO
                    </v-btn>
                  </div>
                </v-overlay>
              </div>
            </v-hover>
          </div>
        </v-slide-item>
      </div>
    </v-slide-group>
  </v-sheet>
</template>
<script>
export default {
  props: ["data"],
  data: () => ({
    gameAPI: "https://api.prerelease-env.biz",
    queenOfGodsGame: { id_game_simple: "vs10egrich", nome_jogo: "Queen of Gods", id_tipo: "vs" },
    model: 0,
    videoLoaded: false,
  }),
  methods: {
    gameClicked(game, isFreeGame) {
      this.$emit("gameClicked", game, isFreeGame);
    },
    goGamesCategory(category, seeAll) {
      this.$emit("goGamesCategory", category, seeAll);
    },
  },
};
</script>
<style scoped>
.casino-slider {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;
}
.casino-slider::-webkit-scrollbar {
  display: none;
  width: 0px;
  background: transparent;
}
.v-skeleton-loader.v-skeleton-loader--is-loading >>> .v-skeleton-loader__image {
  height: 100%;
}
.videoLiveCasino {
  border-radius: 8px;
  margin: 20px 0 24px 0;
}
.videoLiveCasinoMobile {
  border-radius: 8px;
  margin: 10px 0 12px 0;
}
.neonLine {
  position: relative;
}
.neonLineBlur {
  position: absolute;
  display: block;
  width: 100%;
  top: -10px;
  border: 4px solid var(--v-primary-base);
  filter: blur(4px);
} 
.neonLineWhite {
  position: absolute;
  content: "";
  width: 100%;
  height: 1px;
  top: -6px;
  border-radius: 8px;
  background-color: #FFFFFF;
  filter: blur(0);
}
</style>
